<div class="dashletBody__options">
  <div class="dashletBody__event-period">
    @switch (ppDashlet.period) {
      @case (dashletPeriods.DAY) {
        <h6>{{ 'today' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.WEEK) {
        <h6>{{ 'this_week' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.LAST_WEEK) {
        <h6>{{ 'last_7_days' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.MONTH) {
        <h6>{{ 'this_month' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.LAST_MONTH) {
        <h6>{{ 'last_30_days' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.YEAR) {
        <h6>{{ 'this_year' | ppTranslate }}</h6>
      }
      @case (dashletPeriods.LAST_YEAR) {
        <h6>{{ 'last_365_days' | ppTranslate }}</h6>
      }
    }
  </div>
</div>

<div class="dashletBody__event-count">
  {{ eventsNumber }}
</div>

<div class="dashletBody__event-title">
  @switch (ppDashlet.name) {
    @case (dashletTypes.DEFECT_CREATE) {
      @if (eventsNumber !== 1) {
        {{ 'dashlet_export_points_created' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'point_created_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.COMMENT_CREATE) {
      @if (eventsNumber !== 1) {
        {{ 'comments_made' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'comment_created_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.HIGH) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_high_priority_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_high_priority_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.MEDIUM) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_medium_priority_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_medium_priority_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.LOW) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_low_priority_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_low_priority_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.OPEN) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_open_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_open_dashboard_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.IN_PROGRESS) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_in_progress_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_in_progress_dashboard_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.ONHOLD) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_on_hold_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_on_hold_dashboard_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.CLOSED) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_completed_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_completed_dashboard_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.TO_REVIEW) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_review_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_review_dashboard_one' | ppTranslate }}
      }
    }
    @case (dashletTypes.CANCELED) {
      @if (eventsNumber !== 1) {
        {{ 'points_changed_to_canceled_dashboard_other' | ppTranslate }}
      }
      @if (eventsNumber === 1) {
        {{ 'points_changed_to_canceled_dashboard_one' | ppTranslate }}
      }
    }
  }
</div>
